import React from "react"
import styled, { css } from "styled-components"
import { AppFunctionComponent } from "../../../types"
import CartIcon from "../../commerce/cart-icon/cart-icon.component"
import Avatar from "../user-avatar.component"

export const controlStyle = css`
  position: relative;
  margin-left: 20px;
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    margin-left: 30px;
    margin-right: 0;
  }
`

const UserAvatar = styled(Avatar)`
  ${controlStyle}
  padding: 0;
`

const CartControl = styled(CartIcon)`
  ${controlStyle};
`

const ControlsArea = styled.div`
  position: relative;
  display: flex;
  flex: 2;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  z-index: 2;
`

const Controls: AppFunctionComponent = ({ children }) => {
  return (
    <ControlsArea>
      <>
        <UserAvatar />
        {/* This span is necessary to prevent elements breaking after refresh (MEC-58) */}
        <span />
        <CartControl data-testid={"commerce-cart"} />
      </>
      {children}
    </ControlsArea>
  )
}

export default Controls
